<template>
  <div>
    <!--顶部按钮-->
    <div class="app-container">
      <div style="height: 30px">
        <vxe-button type="primary" v-auth="`EXPORT`" @click="deriveFun">导出</vxe-button>
        <div style="float: right; color: #848484; display: flex; line-height: 28px">
          <div v-if="!showFilter">
            <el-select v-if="activeName==='first'" v-model="queryCondition.regionId" placeholder="请选择经理部" style="margin-right: 1rem">
              <el-option v-for="item in sectorList" :key="item.sectorId" :label="item.sectorName" :value="item.sectorId" />
            </el-select>
            <el-input v-model="queryCondition.operator" :placeholder="placeholderMsg" clearable style="width: 200px; margin-right: 1rem" @change="queryByPage()" />
          </div>
          <div>
            <vxe-button v-if="!showFilter" status="primary"  class="filter-search-item" @click="handSearch()">搜索</vxe-button>
            <vxe-button v-if="!showFilter" type="info" class="filter-search-item" @click="resetForm">重置</vxe-button>
            <vxe-button v-if="activeName==='first'" type="warning"  @click="cb">
              {{ showFilter ? '收起' : '筛选' }}
            </vxe-button>
          </div>
        </div>
      </div>
      <!--筛选拓展-->
      <div style="margin-top: 10px">
        <el-collapse-transition>
          <div v-if="showFilter">
            <div v-if="showFilter">
              <br>
              <el-form label-width="110px" class="SiftActivity UniformCss">
                <el-row>
                  <el-col :span="4">
                    <a-form-model-item label="提报名称：">
                      <el-input v-model="queryCondition.applyName" clearable />
                    </a-form-model-item>
                  </el-col>
                  <el-col :span="4">
                    <a-form-model-item label="提报编码：">
                      <el-input v-model="queryCondition.applyCode" clearable />
                    </a-form-model-item>
                  </el-col>
                  <el-col :span="4">
                    <a-form-model-item label="经理部：">
                      <el-select v-model="queryCondition.regionId" placeholder="请选择经理部">
                        <el-option v-for="item in sectorList" :key="item.sectorId" :label="item.sectorName" :value="item.sectorId" />
                      </el-select>
                    </a-form-model-item>
                  </el-col>
                  <el-col :span="4">
                    <a-form-model-item label="经销商：">
                      <el-input v-model="queryCondition.dealerShortName" clearable />
                    </a-form-model-item>
                  </el-col>
                  <el-col :span="4">
                    <a-form-model-item label="预算类型：">
                      <el-select v-model="queryCondition.budgetTypeCode">
                        <el-option v-for="item in budgetData" :key="item.valueCode" :label="item.valueName" :value="item.valueCode" />
                      </el-select>
                    </a-form-model-item>
                  </el-col>
                  <el-col :span="4">
                    <a-form-model-item label="审批类型：">
                      <el-select v-model="queryCondition.eventType">
                        <el-option v-for="(item, i) in typesOfPresentation" :key="i" :value="item.value" :label="item.value" />
                      </el-select>
                    </a-form-model-item>
                  </el-col>
                  <a-col :span="4">
                    <a-form-item label="品系：">
                      <a-select v-model="queryCondition.strainsName" clearable style="margin-right: 1rem">
                        <a-select-option
                            v-for="item in carStrainsDS"
                            :key="item.strainsCode"
                            :value="item.strains" >{{item.strains}}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <el-col :span="4">
                    <a-form-model-item label="操作人：">
                      <el-input v-model="queryCondition.operator" clearable />
                    </a-form-model-item>
                  </el-col>
                  <el-col :span="4">
                    <a-form-model-item label="操作节点：">
                      <el-input v-model="queryCondition.eventNode" clearable />
                    </a-form-model-item>
                  </el-col>
                  <el-col :span="4">
                    <a-form-model-item label="接收时间从：">
                      <el-date-picker style="width: 190px;" v-model="queryCondition.arriveTimeBegin" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" />
                    </a-form-model-item>
                  </el-col>
                  <el-col :span="4">
                    <a-form-model-item label="至：">
                      <el-date-picker style="width: 190px;" v-model="queryCondition.arriveTimeEnd" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" />
                    </a-form-model-item>
                  </el-col>
                  <el-col :span="4">
                    <a-form-model-item label="完成时间从：">
                      <el-date-picker style="width: 190px;" v-model="queryCondition.finishTimeStart" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" />
                    </a-form-model-item>
                  </el-col>
                  <el-col :span="4">
                    <a-form-model-item label="至：">
                      <el-date-picker style="width: 190px;" v-model="queryCondition.finishTimeEnd" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" />
                    </a-form-model-item>
                  </el-col>
                </el-row>
              </el-form>
              <div slot="footer" style="text-align: center; padding-bottom: 10px">
                <vxe-button type="info" @click="resetForm">重置</vxe-button>
                <vxe-button status="primary"  @click="handSearch()">搜索</vxe-button>
              </div>
            </div>
          </div>
        </el-collapse-transition>
      </div>
      <!--table列表-->
      <vxe-table
        ref="xTable"
        v-loading="listLoading"
      :align="allAlign"
        :max-height="$store.state.app.height - 130 < 500 ? 500 : $store.state.app.height - 130"
        border
        show-header-overflow
        show-overflow
        class="mytable-scrollbar"
        :column-config="{ resizable: true }"
        stripe
        round
        :sort-config="{remote: true}"
        :scroll-y="{ enabled: false }"
        :row-config="{ isHover: true }"
        :data="tableData"
        @sort-change="listSortMethod"
      >
        <vxe-column type="checkbox" width="60" align="center" />
        <vxe-column type="seq" title="序号" width="60" align="center" :visible="false" />
        <vxe-column field="orderId" :visible="false" title="id" width="150" />
        <vxe-column field="applyCode" title="提报编码" width="120" align="center" />
        <vxe-column field="sectorName" title="经理部" width="120" />
        <vxe-column field="dealerShortName" title="经销商" width="120" />
        <vxe-column field="applyName" title="活动名称" width="130" align="center" />
        <vxe-column field="budgetTypeName" title="预算类型" width="120" />
        <vxe-column field="oneLevelName" title="一级来源" width="120" />
        <vxe-column field="twoLevelName" title="二级来源" width="120" />
        <vxe-column field="threeLevelName" title="三级来源" width="120" />
        <vxe-column field="eventType" title="审批类型" width="100">
          <template #default="{ row }">
            <div class="operate">
              <!-- <span v-if="row.eventType==='时间调整'" style="color:#67C23A">{{ row.eventType }}</span> -->
              <span v-if="row.eventType==='核销审批'" style="color:#F56C6C">{{ row.eventType }}</span>
              <span v-if="row.eventType==='提报审批'" style="color:#409EFF">{{ row.eventType }}</span>
            </div>
          </template>
        </vxe-column>
        <vxe-column field="strainsNameList" title="品系" width="150" />
        <vxe-column field="operator" title="操作人" width="100" align="center" />
        <vxe-column field="eventNode" title="操作节点名称" width="200" align="center" />
        <vxe-column field="arriveTime" title="接收时间" width="140" />
        <vxe-column field="finishTime" title="完成时间" width="140" />
        <vxe-column field="delayHour" title="时差(天)" width="120" align="center" />
        <vxe-column field="isDelay" title="是否超期" width="120" align="center">
          <template #default="{ row }">
            <div class="operate">
              <span v-if="row.isDelay==='0'" style="color:#67C23A">否</span>
              <span v-if="row.isDelay==='1'" style="color:#F56C6C">是</span>
            </div>
          </template>
        </vxe-column>
        <vxe-column field="orderId" title="审批信息" width="120" align="center" fixed="right">
          <template #default="{ row }">
            <div class="operate" style="height:30px">
              <a-button type="link" v-auth="`VIEW`" @click="viewApproveDetail(row)">详情</a-button>
            </div>
          </template>
        </vxe-column>
      </vxe-table>
      <vxe-pager
        :current-page="pagination.current"
        :page-size="pagination.size"
        :total="pagination.total"
        :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
        @page-change="changePage"
      />
    </div>
    <!--导入对话框 -->

    <el-dialog title="审批信息" :visible.sync="taskDialogVisible" width="60%">
      <vxe-table
        ref="xApprove"
        border
        show-header-overflow
        show-overflow
        :column-config="{ resizable: true }"
        stripe
        round
        :loading="approveLoading"
        max-height="370"
        :align="allAlign"
        :scroll-y="{ enabled: false }"
        :data="taskListData"
        :reserve="true"
        :row-config="{ isCurrent: true, isHover: true }"
      >
        <vxe-column type="seq" title="序号" width="60" />
        <vxe-column field="displayName" title="节点名称" />
        <vxe-column field="operatorName" title="审批人" />
        <vxe-column field="operateType" title="操作类型" />
        <vxe-column field="approveMsg" title="审批意见" />
        <vxe-column field="finishTime" title="处理时间" />
      </vxe-table>
    </el-dialog>

    <el-dialog title="流程信息" :visible.sync="processDialogVisible" width="60%">
      <vxe-table
        ref="xProcess"
        border
        show-header-overflow
        show-overflow
        :column-config="{ resizable: true }"
        stripe
        round
        :loading="processLoading"
        max-height="370"
        :align="allAlign"
        :scroll-y="{ enabled: false }"
        :data="processListData"
        :reserve="true"
        :row-config="{ isCurrent: true, isHover: true }"
      >
        <vxe-column type="seq" title="执行顺序" width="100" />
        <vxe-column field="displayName" title="节点名称" />
      </vxe-table>
    </el-dialog>
    <!--导出对话框 -->
    <el-dialog title="选择导出项" :visible.sync="dialogVisible" width="400px">
      <el-radio-group v-model="ExportItem">
        <el-radio :label="1">导出当前页</el-radio>
        <el-radio :label="2" :disabled="disabled">导出已选择项</el-radio>
        <el-radio :label="3">导出全部</el-radio>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <vxe-button @click="dialogVisible = false">取 消</vxe-button>
        <vxe-button status="primary" :loading="outExcelButtonLocading" @click="exportXlsxFun">确 定</vxe-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import permission from '@/directive/permission/index.js' // 权限判断指令
import { outExcel } from '@/utils/Excel/outExcel'
import { findSectorList } from '@/api/base-data'
import { exportDelayApproves, findDelayApproves, findHistTask, findTaskInfos, findProcessInfos } from '@/api/wf_process'
import {queryCarStrainsInfo, queryValueTypeByCode} from '@/api/activity' // 活动类接口

const defaultPagination = {
  total: 0,
  size: 20,
  current: 1
}
const defaultTypesOfPresentation = [
  /*{
    code: 1,
    value: '时间调整'
  },*/
  {
    code: 2,
    value: '提报审批'
  },
  {
    code: 3,
    value: '核销审批'
  }
]

export default {
  name: 'DelayApproveList',
  // inject: ['reload'],
  // directives: { permission },
  data() {
    return {
      showFilter: false,
      // pagination: Object.assign({}, defaultPagination),
      pagination2: Object.assign({}, defaultPagination),
      listLoading: false,
      listLoading2: false,
      processDialogVisible: false,
      processLoading: false,
      taskListData: [],
      sectorList: [],
      budgetData: [],
      // queryCondition: {},
      typesOfPresentation: defaultTypesOfPresentation,
      taskDialogVisible: false,
      approveLoading: false,
      tableData2: [],
      processListData: [],
      carStrainsDS: [],
      activeName: 'first',
      tableData: [],
      sort: 'tmp.finishTime desc',
      allAlign: 'center',
      placeholderMsg: '操作人',
      nameOrCode: '',
      // 导出对话框
      dialogVisible: false,
      disabled: true, // 已选择按钮是否禁用
      outExcelButtonLocading: false,
      ExportItem: 0
    }
  },
  computed: {
    queryCondition() {
      return this.$store.state.undoListPage.queryCondition
    },
    pagination() {
      return this.$store.state.undoListPage.pagination
    },
    // showFilter() {
    //   return this.$store.state.undoListPage.showFilter
    // }
  },
  watch: {
    activeName(val) {
      if (val === 'first') {
        this.placeholderMsg = '活动名称/活动编码/经销商名称'
      } else {
        this.$store.commit('undoListPage/updateShowFilter', false)
        this.placeholderMsg = '活动名称/活动编码'
      }
    }
  },
  created() {
    // 获取表格数据
    this.queryByPage()
    // 获取大区
    this.getSectorList()
    // 获取预算类型
    this.getBudgettype()
    //获取品系
    this.getCarStrains()
  },
  mounted() {},
  methods: {
    deriveFun() {
      this.dialogVisible = true
      // 判断是否选中
      this.disabled = this.activeName === 'first' ? this.$refs.xTable.selection.length < 1 : this.$refs.xTable2.selection.length < 1
    },
    // 导出表格
    async exportXlsxFun() {
      // 需要导出的数据
      let data = []
      this.outExcelButtonLocading = true
      if (this.ExportItem == 3) {
        const queryData = {
          page: this.pagination.current,
          limit: this.pagination.size,
          sort: this.sort,
          conditionsAnd: [
            {
              code: 'operator',
              symbol: 'like',
              values: this.queryCondition.operator
            },
            {
              code: 'applyCode',
              symbol: 'like',
              values: this.queryCondition.applyCode
            },
            {
              code: 'applyName',
              symbol: 'like',
              values: this.queryCondition.applyName
            },
            {
              code: 'eventNode',
              symbol: 'like',
              values: this.queryCondition.eventNode
            },
            {
              code: 'dealerShortName',
              symbol: 'like',
              values: this.queryCondition.dealerShortName
            },
            {
              code: 'arriveTime',
              symbol: 'between',
              values: this.queryCondition.arriveTimeBegin,
              valuesTwo: this.queryCondition.arriveTimeEnd
            },
            {
              code: 'finishTime',
              symbol: 'between',
              values: this.queryCondition.finishTimeStart,
              valuesTwo: this.queryCondition.finishTimeEnd
            },
            {
              code: 'activityName',
              symbol: 'like',
              values: this.queryCondition.activityName
            },
            {
              code: 'budgetTypeCode',
              symbol: '=',
              values: this.queryCondition.budgetTypeCode
            },
            {
              code: 'regionId',
              symbol: '=',
              values: this.queryCondition.regionId
            },
            {
              code: 'eventType',
              symbol: '=',
              values: this.queryCondition.eventType
            },
            {
              code: 'eventNode',
              symbol: 'like',
              values: this.queryCondition.eventNode
            },
            {
               code: 'strainsName',
               symbol: 'like',
               values: this.queryCondition.strainsName
            }
          ]
        }
        exportDelayApproves(queryData).then(val => {
          this.$exportExcelData(val, `审批信息表${new Date().Format('yyyy年MM月DD日 HH点mm分')}.xlsx`)
          this.dialogVisible = false
          this.outExcelButtonLocading = false
        })
      } else {
        if (this.ExportItem == 1) {
          data = this.tableData
        }
        if (this.ExportItem == 2) {
          data = this.$refs.xTable.selection
        }
        const table = []
        for (var i = 0; i < data.length; i++) {
          var params = {
            提报编码: data[i].applyCode,
            经理部: data[i].sectorName,
            经销商: data[i].dealerShortName,
            活动名称: data[i].applyName,
            预算类型: data[i].budgetTypeName,
            一级来源: data[i].oneLevelName,
            二级来源: data[i].twoLevelName,
            三级来源: data[i].threeLevelName,
            审批类型: data[i].eventType,
            品系: data[i].strainsNameList,
            操作人: data[i].operator,
            操作节点名称: data[i].eventNode,
            接收时间: data[i].arriveTime,
            完成时间: data[i].finishTime,
            时差: data[i].delayHour,
            是否超期: data[i].isDelay=== 1?'是':'否'
          }
          table[i] = params
        }
        const wch = [15, 15, 15, 15, 15, 25, 15, 15, 15, 15, 15, 15]
        outExcel('审批信息表', table, wch)
        // 关闭弹窗
        this.dialogVisible = false
        this.outExcelButtonLocading = false
      }
    },
    // 获取大区
    getSectorList() {
      findSectorList().then(res => {
        if (res.code === 1 && res.data) {
          this.sectorList = res.data
        }
      })
    },
    // 获取预算类型
    getBudgettype() {
      queryValueTypeByCode({ typeCode: 'budgetary', page: 1, limit: 999 }).then(res => {
        if (res.code === 1) {
          this.budgetData = res.data.list
        }
      })
    },
    listSortMethod({ sortList }) {
      let sort = ''
      for (let i = 0; i < sortList.length; i++) {
        if (i !== 0) {
          sort = sort + ','
        }
        sort = sort + sortList[i].field + ' ' + sortList[i].order
      }
      this.sort = sort
      this.queryByPage()
    },
    viewProcessDetail(row) {
      this.processDialogVisible = true
      this.processLoading = true
      const param = {
        orderId: row.orderId
      }
      findProcessInfos(param).then(res => {
        if (res.code === 1 && res.data) {
          this.processListData = res.data
          this.processLoading = false
        }
      })
    },
    viewApproveDetail(row) {
      this.taskDialogVisible = true
      this.approveLoading = true
      const param = {
        orderId: row.orderId
      }
      findTaskInfos(param).then(res => {
        if (res.code === 1 && res.data) {
          this.taskListData = res.data
          this.taskListData.forEach(item => {
            if (!item.his) {
              item.operatorName = row.currentApproveUser
              item.finishTime = '正在处理'
            }
          })
          this.approveLoading = false
        }
      })
    },
    viewDetail(row) {
      if (row.eventType === '提报审批') {
        this.$router.push({
          path: `market_activity/center/signDetails/${row.eventId}`
        })
      }
      if (row.eventType === '核销审批') {
        this.$router.push({
          path: `market_activity/center/DetailedReimbursement/${row.eventId}`
        })
      }
      if (row.eventType === '时间调整') {
        this.$router.push({
          path: `market_activity/center/editSignActivityDate/${row.eventId}/approve`
        })
      }
    },
    // 分页
    changePage({ currentPage, pageSize }) {
      this.pagination.current = currentPage
      if (pageSize != this.pagination.size) this.pagination.current = 1
      this.pagination.size = pageSize
      this.queryByPage()
    },
    changePage2({ currentPage, pageSize }) {
      this.pagination2.current = currentPage
      if (pageSize != this.pagination2.size) this.pagination2.current = 1
      this.pagination2.size = pageSize
      this.queryByPage2()
    },
    // 重置筛选
    resetForm() {
      this.$store.commit('undoListPage/resetQueryCondition')
      this.handSearch()
    },
    // 搜索表格数据
    queryByPage(e) {
      if (e) this.pagination.current = e

      // 保存搜索条件到store
      this.$store.commit('undoListPage/updatePagination', this.pagination)
      this.$store.commit('undoListPage/updateQueryCondition', this.queryCondition)

      // 筛选条件
      const queryData = {
        page: this.pagination.current,
        limit: this.pagination.size,
        sort: this.sort,
        conditionsAnd: [
          {
            code: 'operator',
            symbol: 'like',
            values: this.queryCondition.operator
          },
          {
            code: 'applyCode',
            symbol: 'like',
            values: this.queryCondition.applyCode
          },
          {
            code: 'applyName',
            symbol: 'like',
            values: this.queryCondition.applyName
          },
          {
            code: 'eventNode',
            symbol: 'like',
            values: this.queryCondition.eventNode
          },
          {
            code: 'dealerShortName',
            symbol: 'like',
            values: this.queryCondition.dealerShortName
          },
          {
            code: 'arriveTime',
            symbol: 'between',
            values: this.queryCondition.arriveTimeBegin,
            valuesTwo: this.queryCondition.arriveTimeEnd
          },
          {
            code: 'finishTime',
            symbol: 'between',
            values: this.queryCondition.finishTimeStart,
            valuesTwo: this.queryCondition.finishTimeEnd
          },
          {
            code: 'activityName',
            symbol: 'like',
            values: this.queryCondition.activityName
          },
          {
            code: 'budgetTypeCode',
            symbol: '=',
            values: this.queryCondition.budgetTypeCode
          },
          {
            code: 'regionId',
            symbol: '=',
            values: this.queryCondition.regionId
          },
          {
            code: 'eventType',
            symbol: '=',
            values: this.queryCondition.eventType
          },
          {
             code:'strainsName',
             symbol: 'like',
             values: this.queryCondition.strainsName
          }
        ]
      }
      this.listLoading = true // 开启加载动画
      findDelayApproves(queryData).then(res => {
        if (res.code === 1 && res.data) {
          this.tableData = res.data.list
          this.pagination.total = res.data.total
          this.listLoading = false
        }
      })
    },
    // 搜索表格数据
    queryByPage2(e) {
      if (e) this.pagination2.current = e
      // 筛选条件
      const queryData = {
        page: this.pagination2.current,
        limit: this.pagination2.size,
        sort: this.sort,
        conditions: [{
          code: 'eventName',
          symbol: 'like',
          values: this.queryCondition.nameOrCode
        }]
      }
      this.listLoading2 = true // 开启加载动画
      findHistTask(queryData).then(res => {
        if (res.code === 1 && res.data) {
          this.tableData2 = res.data.list
          this.pagination2.total = res.data.total
          this.listLoading2 = false
        }
        this.listLoading2 = false
      })
    },
    handSearch() {
      if (this.activeName === 'first') {
        this.queryByPage(1)
      } else {
        this.queryByPage2(1)
      }
    },
    cb() {
      // this.$store.commit('undoListPage/updateShowFilter', !this.showFilter)
      this.showFilter = !this.showFilter
    },
    // 获取品系
    getCarStrains() {
      queryCarStrainsInfo().then(res => {
        if (res.code === 1) {
          this.carStrainsDS = res.data.list
        }
      })
    }
  }
}
</script>
<style lang="less">
.el-input--medium .el-input__inner {
  height: 30px;
}
.operate {
  display: flex;
  justify-content: space-around;
}
.el-link {
  font-size: 12px;
}
.load-buttom {
  text-decoration: none;
  float: right;
  height: 30px;
  padding: 0 10px;
  text-align: right;
  line-height: 30px;
  color: #00a7e5;
  display: inline-block;
  font-size: 12px;
}
.load-buttom:hover {
  color: #00b7bf;
}
.err-box {
  margin-top: 10px;
}
.pic-box {
  display: inline-block;
  padding: 5px;
}
.el-input__inner {
  height: 30px;
}
.el-select .el-input .el-select__caret  {
  line-height: 30px;
}
</style>
